// extracted by mini-css-extract-plugin
export default {"footer":"style-module_footer__92668","container":"style-module_container__bb6f2","copyright":"style-module_copyright__dbc37","icp":"style-module_icp__90f3d"};